import { render, staticRenderFns } from "./EditDocutaxClient.vue?vue&type=template&id=47351a81&"
import script from "./EditDocutaxClient.vue?vue&type=script&lang=js&"
export * from "./EditDocutaxClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports